<template>
  <div style="padding: 0 40px;">
    <Loading ref="loading" minHeight="40vh" :enableOnScrollEnd="true" @onscrollend="onScrollEnd">
      <div v-if="commentList.length">
        <div v-for="comment in commentList" :key="comment.id" style="display: flex;padding:8px;">
          <img
            style="border-radius: 50%; width: 50px; height: 50px"
            :src="urls.getUserImageSrc(user)"
            :alt="user.userName"
            
          />
          <div class="comment-block">
            <div class="comment-content">
              {{comment.comment}}
            </div>
            <div class="comment-project">
              <router-link :to="`/${comment.publicPage.user.userName}/${comment.publicPage.titleURL}`">
                {{comment.publicPage.title}}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <h5 v-else style="margin-top: 1rem; margin-bottom: 1rem">コメントはありません</h5>
    </Loading>
  </div>
</template>
<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import Loading from "@/component/Loading.vue"
import CommentByAUserResp from '@/interface/api/CommentByAUserResp';
import { Ref } from 'vue-property-decorator';
import UserResp from '@/interface/api/UserResp';
import Pageable from '@/interface/api/common/Pageable';
import urls from "@/URLs";


@Options({
  components:{
    Loading,
  },
  props:{
    user:{
      type:Object
    }
  }
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  //mounted前のlifesycleだと初期化されていないので使用できない点に注意
  @Ref() readonly loading = null as any as Loading;
  readonly user!:UserResp;
  readonly urls = urls;
  

  commentList = [] as CommentByAUserResp[];

  pageable = {
    size: 10,
    page: 0,
  } as Pageable;

  async load(){
    try {
      this.loading?.start()
      let res = await this.$root.restAccess.getAllComments(this.user.userName, this.pageable);
      if(res.ok){
        this.updateData(await res.json());
      }
    } catch (e) {
      console.error(e);
    }
    this.loading?.finish()
  }


  updateData(data:  CommentByAUserResp[]) {
    this.commentList.push(...data);
    //次回読み込みのためにページを一つ増やしておく
    this.pageable.page += 1;

    // 要求数戻ってきたら、次の要求を有効化
    if (data.length === this.pageable.size) {
      this.loading.enableNextScrollEnd()
    }
  }
  onScrollEnd(){
    this.load()
  }

  created() {
    this.load()
  }
}
</script>


<style lang="scss" scoped>
.comment-block{
  width:100%;
  padding: 4px 10px;
  display:flex;

  .comment-content{
    flex-grow: 1;
    display: flex;
    align-items: center;
  }

  .comment-project{
    font-size: small;
    opacity:0.9;
    display: flex;
    align-items: center;
    min-width: 5rem;
    justify-content: right;
    word-break: break-all;
  }
}
</style>
